/* pauseAdSelector.tsx */
import PauseTeadsHandler from './teads/pauseTeadsHandler';
import PauseAd from '@components/sections/pauseAd/pauseAd';
import { AdSdkProvider } from '@shared/types/enums/ads';
import { adsSelector } from '@shared/store/slices/ads.slice';
import { routerSelector } from '@shared/store/slices/router.slice';
import { useAppSelector } from '@shared/store/hooks';
import Pages from '@pages';

/**
 * PauseAdSelector component. Selects and displays a PauseAd.
 */
export default function PauseAdSelector() {
  const { pauseAd } = useAppSelector(adsSelector);
  const { route } = useAppSelector(routerSelector);

  /**
   * If not in a player based page or not active, return
   */
  if (![Pages.PLAYER, Pages.ZAPPER].includes(route.Page)) {
    return null;
  }
  /**
   * Select the appropriate ad handler based on the ad provider
   */
  switch (pauseAd?.sdkProvider) {
    case AdSdkProvider.TEADS:
      return <PauseTeadsHandler />;
    case AdSdkProvider.IMA:
      return <PauseAd />;
    default:
      return null;
  }
}
